module.exports = __webpack_public_path__ + "img/artist_header_en.678f601.webp";